import templateUrl from "../resource-category-video-url-main.html";

export const resourceCategoryVideoUrlMainComponent = {
  templateUrl,
  bindings: {
    details: "<",
  },
  controller: class resourceCategoryVideoUrlMainComponent {
    constructor(
      $state,
      toastr,
      resourcesService,
      $stateParams,
      VideoUrlService
    ) {
      "ngInject";

      this.$state = $state;
      this.toastr = toastr;
      this.$stateParams = $stateParams;
      this.resourcesService = resourcesService;
      this.VideoUrlService = VideoUrlService;
    }

    $onInit() {
      this.disableButtons = false;
      this.slug = this.$stateParams.slug;
      this.hasVideoValidationError = false;
      this.saveData = angular.copy(this.details);
      this.url =
        (this.details &&
          this.details.categoryDetails &&
          this.details.categoryDetails.value.videoUrl) ||
        null;
    }

    onSubmit() {
      if (this.url) {
        const isVideoUrlValid = this.VideoUrlService.isVideoUrlValid(this.url);
        this.hasVideoValidationError = !isVideoUrlValid;

        if (!this.hasVideoValidationError) {
          this.hasVideoValidationError = false;
          this.disableButtons = true;
          this.resourcesService
            .updateResourceVideoUrl(this.slug, { url: this.url })
            .then((_) => {
              this.toastr.success("Details updated successfully");
              this.$state.go("resourceCategory", { slug: this.slug });
            })
            .catch((errmsg) => {
              this.disableButtons = false;
              this.toastr.error(errmsg);
            });
        }
      }
    }

    onCancel() {
      this.$state.go("resourceCategory", { slug: this.slug });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/resources/resource-category-video-url-main/resource-category-video-url-main.component.js